import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import PlanSection from "../components/PlanSection";
import TestimonialSection from "../components/TestimonialSection";
import FooterSection from "../components/FooterSection";
import NumberCount from "../components/NumberCount";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MsportModal from "../components/MsportModal";


export default function Plans() {
  const { user } = useContext(UserContext);
  const [userSubscription, setUserSubscription] = useState({
    Premium: false,
  });
  const navigate = useNavigate();
      const [showModal, setShowModal] = React.useState(true);
  

  useEffect(() => {
    if (user) {
      axios
        .get(`/auth/profile/${user?.id}`)
        .then(({ data }) => {
          if (data) {
            setUserSubscription(data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user, setUserSubscription]);

  const isSubscribed =
    userSubscription && new Date(userSubscription.expiresAt) > new Date();

  useEffect(() => {
    if (isSubscribed) {
      navigate("/predictions/premium", { replace: true });
    }
  }, [isSubscribed, navigate]);

  return (
    <div>
       {showModal && <MsportModal setShowModal={setShowModal} />}
      <Header />
      <PagesHero page={"plan"} />
      <PlanSection />
      <TestimonialSection />
      <NumberCount />
      <FooterSection />
    </div>
  );
}
